






import { Component, Vue } from 'vue-property-decorator';
import MelosCover from '@/components/MelosCover.vue';

@Component({
  components: {
    MelosCover,
  },
})
export default class PlayingView extends Vue {
}
